import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { BOOKING_LINK, services } from '../data/homepage';
export function WaysWeHelp() {
  return <section aria-labelledby="help-heading" className="on-light bg-paper py-24 md:py-32" data-id="element-160" data-mp="3tfn673u2bjx2">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-161" data-mp="292l00qov67y">
        <Reveal className="max-w-3xl" data-id="element-162" data-mp="29m3bik93wmi">
          <h2 id="help-heading" className="font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-163" data-mp="pyohuhjl99cs">
            Ways we help
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-164" data-mp="uwgchjbmb9ko" />
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-3 md:gap-8" data-id="element-165" data-mp="g7tybkxq8nv1">
          {services.map((service, i) => <li key={service.title} data-id="element-166" data-mp="l6n7x29w7upx" data-mpi={i}>
              <Reveal delay={i * 0.05} className="relative flex h-full flex-col rounded-sm border border-navy/10 bg-white p-8 md:p-10" data-id="element-167" data-mp="l5lpgcqjs5y6">
                {service.comingSoon && <span className="absolute right-6 top-6 rounded-sm bg-honor px-2.5 py-1 text-xs font-semibold uppercase tracking-wider text-paper" data-id="element-168" data-mp="3p463vemfecs7">
                    Coming Soon
                  </span>}
                <h3 className="pr-24 font-serif text-2xl font-semibold leading-snug text-navy" data-id="element-169" data-mp="1sev3slakh47">{service.title}</h3>
                <p className="mt-4 text-lg leading-relaxed text-charcoal" data-id="element-170" data-mp="3t4q26liqjmfx">{service.body}</p>
                <div className="mt-auto pt-8" data-id="element-171" data-mp="bo83r0vw3qgp">
                  <div className="border-t border-navy/10 pt-6" data-id="element-172" data-mp="6qonxwjjn5mn">
                    <a href={BOOKING_LINK} className="inline-flex items-center gap-2 text-lg font-semibold text-navy transition-colors duration-150 ease-out hover:text-honor" data-id="element-173" data-mp="6qgfcgugemh9">
                      Ask us on your free call
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-174" data-mp="2micjpomtms3v" />
                    </a>
                  </div>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}